/**
 * B-24: how loudly a withholding message from the proposal / payment run should be shown.
 * Only messages that mean "money may not be withheld" are warnings: a supplier with no VDS or TDS rule,
 * a rule that was cut down to fit the amount paid, a rule that is inactive or missing, and a failed load.
 * Everything else (exemption note, below-threshold) is plain information.
 */
export type WithholdingMessageSeverity = 'warning' | 'info';

const WARNING_PATTERNS: RegExp[] = [
  /^No (VDS|TDS) rule is set/,
  / reduced from .* to /,
  /rule is inactive or missing/,
  /^Could not /,
];

export const withholdingMessageSeverity = (message: string): WithholdingMessageSeverity =>
  (WARNING_PATTERNS.some(p => p.test(message)) ? 'warning' : 'info');
